import { render, staticRenderFns } from "./PelatihanSertifikat.vue?vue&type=template&id=d353c194&scoped=true"
import script from "./PelatihanSertifikat.vue?vue&type=script&lang=js"
export * from "./PelatihanSertifikat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d353c194",
  null
  
)

export default component.exports